import React from "react";
import { Container, Grid, Paper, Typography, Box } from "@mui/material";
import DOMPurify from "dompurify";
import { COLORS } from "../../constants";

const DesktopAbout = ({ historySections, fourBoxes }) => {
  const sanitizedMarkup = (html) => {
    return { __html: DOMPurify.sanitize(html) };
  };
  return (
    <Container sx={{ mt: 8, mb: 8 }} disableGutters>
      {/* Legacy Box */}
      <Box
        sx={{
          backgroundImage: "url(/images/cogs.svg)",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: 400,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mb: 6,
          mt: -5,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: "var(--font-size-xxl)",
            fontWeight: 600,
            mb: 4,
            mt: 15,
          }}
        >
          Legacy drives Argus Motors forward.
        </Typography>
        <Box
          sx={{
            backgroundColor: COLORS.themeBlack,
            display: "inline-block",
            px: 4,
            py: 2,
            borderRadius: "8px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: COLORS.themeYellow,
              fontWeight: 500,
            }}
          >
            Quality parts, trusted service
          </Typography>
        </Box>
      </Box>

      {/* Four Boxes Section */}
      <Grid container spacing={2} sx={{ mb: 6 }}>
        {fourBoxes.map((box, index) => (
          <Grid key={index} item xs={12} sm={6} md={3}>
            <Box
              sx={{
                backgroundColor: COLORS.white,
                border: `1px solid ${COLORS.border}`,
                borderRadius: "2px",
                px: 3,
                py: 3,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="h6"
                sx={{ color: COLORS.darkText, fontWeight: 500, mb: 1 }}
              >
                {box.heading}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: COLORS.lightText, fontWeight: box.fontWeight }}
              >
                {box.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* History Section */}
      <Typography
        variant="h2"
        sx={{
          mb: 5,
          fontSize: "var(--font-size-xxl)",
          color: COLORS.darkText,
          textAlign: "center",
        }}
      >
        History
      </Typography>
      <Box sx={{ position: "relative", mt: 5 }}>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: 2,
            backgroundImage: `linear-gradient(to bottom, transparent 50%, ${
              COLORS.gray || "#ccc"
            } 50%)`,
            backgroundSize: "2px 8px",
            zIndex: 1,
          }}
        />
        {historySections.map((section, index) => (
          <Box
            key={index}
            sx={{
              mb: 6,
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              position: "relative",
              "&:last-child": { mb: 0 },
            }}
          >
            {/* Left Side */}
            <Box
              sx={{
                width: "50%",
                display: "flex",
                justifyContent: "flex-end",
                pr: 4,
              }}
            >
              {index % 2 === 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    mb: 2,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      mr: 2,
                      color: COLORS.darkText,
                      fontSize: "var(--font-size-xxl)",
                    }}
                  >
                    {section.year} -
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 300, fontSize: "var(--font-size-xxl)" }}
                  >
                    {section.title}
                  </Typography>
                </Box>
              ) : (
                <Box sx={{ width: "100%" }}>
                  <img
                    src={section.image}
                    alt={section.title}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "8px",
                      mb: 2,
                    }}
                  />
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    dangerouslySetInnerHTML={sanitizedMarkup(section.text)}
                  />
                </Box>
              )}
            </Box>

            {/* Timeline Dot */}
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                top: "8px",
                transform: "translateX(-50%)",
                width: 20,
                height: 20,
                backgroundColor: COLORS.themeYellow,
                border: `6px solid ${COLORS.themeBlack}`, // Added border
                borderRadius: "50%",
                zIndex: 2,
              }}
            />

            {/* Right Side */}
            <Box
              sx={{
                width: "50%",
                display: "flex",
                justifyContent: "flex-start",
                pl: 4,
              }}
            >
              {index % 2 === 0 ? (
                <Box sx={{ width: "100%" }}>
                  <img
                    src={section.image}
                    alt={section.title}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "8px",
                      mb: 2,
                    }}
                  />
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    dangerouslySetInnerHTML={sanitizedMarkup(section.text)}
                  />
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    mb: 2,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      mr: 2,
                      color: COLORS.darkText,
                      fontSize: "var(--font-size-xxl)",
                    }}
                  >
                    {section.year} -
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 300, fontSize: "var(--font-size-xxl)" }}
                  >
                    {section.title}
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default DesktopAbout;
